"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castToKeywordSource = exports.KeywordSourceSchema = exports.KeywordSource = exports.castToSyncMode = exports.SyncModeSchema = exports.SyncMode = exports.castToKeywordBidStrategy = exports.KeywordBidStrategySchema = exports.KeywordBidStrategy = exports.ObjectiveSchema = exports.castToChannelStructure = exports.ChannelStructureSchema = exports.ChannelStructure = exports.castToPurpose = exports.PurposeSchema = exports.Purpose = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../core");
const cast_1 = require("../utils/cast");
// TODO: This could be renamed RegionPurpose to avoid any confusion with other Purposes
var Purpose;
(function (Purpose) {
    Purpose["BID_DISCOVERY"] = "BD";
    Purpose["KEYWORD_DISCOVERY"] = "KD";
    Purpose["BID_OPTIMISATION"] = "BO";
})(Purpose = exports.Purpose || (exports.Purpose = {}));
exports.PurposeSchema = (0, core_1.StringUnion)([
    // The region is to be used to discover bid prices for keywords
    Purpose.BID_DISCOVERY,
    // The region is to be used to discover new keywords
    Purpose.KEYWORD_DISCOVERY,
    // The region is to be used to optimise (keyword or ad group) bid prices
    Purpose.BID_OPTIMISATION,
], {
    title: "Region Purpose",
    description: "Used by Bid Manager",
});
exports.castToPurpose = (0, cast_1.castToEnum)(Purpose);
var ChannelStructure;
(function (ChannelStructure) {
    // IDEA: All regions in a single campaign, allows virtually no budgeting but very simple.
    // ALL_IN_ONE_CAMPAIGN = "AIO",
    // IDEA: Use a campaign per country. Would be useful for simple AST/ASR soft budged
    ChannelStructure["CAMPAIGN_PER_COUNTRY"] = "CPC";
    // Use an Apple campaign per region - giving very hard (budget) isolation
    ChannelStructure["CAMPAIGN_PER_REGION"] = "CPR";
    // Each Region is divided into a two Apple campaigns (Discovery and Optimisation)  - this enables hard budget constraints.
    ChannelStructure["DISCOVERY_AND_OPTIMISATION_CAMPAIGNS"] = "DOC";
})(ChannelStructure = exports.ChannelStructure || (exports.ChannelStructure = {}));
exports.ChannelStructureSchema = (0, core_1.StringUnion)([
    ChannelStructure.CAMPAIGN_PER_REGION,
    ChannelStructure.DISCOVERY_AND_OPTIMISATION_CAMPAIGNS,
    ChannelStructure.CAMPAIGN_PER_COUNTRY,
], {
    title: "Channel Structure",
    description: "Structure of regions and platform campaigns within this channel",
});
exports.castToChannelStructure = (0, cast_1.castToEnum)(ChannelStructure);
exports.ObjectiveSchema = typebox_1.Type.String({
    title: "Objective",
    description: "User defined objective of the  campaign",
});
var KeywordBidStrategy;
(function (KeywordBidStrategy) {
    KeywordBidStrategy["NONE"] = "NONE";
    KeywordBidStrategy["ALGORITHM"] = "ALGORITHM";
})(KeywordBidStrategy = exports.KeywordBidStrategy || (exports.KeywordBidStrategy = {}));
exports.KeywordBidStrategySchema = (0, core_1.StringUnion)([KeywordBidStrategy.NONE, KeywordBidStrategy.ALGORITHM], {
    title: "Keyword Bid Strategy",
    description: "Strategy for bid price calculation",
    default: KeywordBidStrategy.ALGORITHM,
});
exports.castToKeywordBidStrategy = (0, cast_1.castToEnum)(KeywordBidStrategy);
var SyncMode;
(function (SyncMode) {
    // Plan the sync (capture desired, gather baseline, and plan delta - but do nothing)
    SyncMode["PLAN"] = "PLAN";
    // As per PLAN, but read into our database any changes
    SyncMode["READ"] = "READ";
    // Perform a full two way sync (As per READ but additional update Apple)
    SyncMode["FULL"] = "FULL";
    // Do not sync
    SyncMode["NONE"] = "NONE";
})(SyncMode = exports.SyncMode || (exports.SyncMode = {}));
exports.SyncModeSchema = (0, core_1.StringUnion)([SyncMode.PLAN, SyncMode.READ, SyncMode.FULL, SyncMode.NONE], {
    title: "Synchronisation mode",
    description: "The mode to operate synchronisation",
});
exports.castToSyncMode = (0, cast_1.castToEnum)(SyncMode);
var KeywordSource;
(function (KeywordSource) {
    KeywordSource["CHATGPT"] = "CHATGPT";
    KeywordSource["APPTWEAK"] = "APPTWEAK";
    KeywordSource["GOOGLE"] = "GOOGLE";
    KeywordSource["AWS"] = "AWS";
    KeywordSource["APPLE"] = "APPLE";
})(KeywordSource = exports.KeywordSource || (exports.KeywordSource = {}));
exports.KeywordSourceSchema = (0, core_1.StringUnion)([
    KeywordSource.APPLE,
    KeywordSource.AWS,
    KeywordSource.APPTWEAK,
    KeywordSource.CHATGPT,
    KeywordSource.GOOGLE,
]);
exports.castToKeywordSource = (0, cast_1.castToEnum)(KeywordSource);
